import Page from '@averyano/core/src/classes/Page';
import each from 'lodash/each';
import FadeInAnimation from '../../animations/FadeIn';
import GSAP from 'gsap';
// import GallerySection from './gallery-section';
import ScrollTrigger from 'gsap/ScrollTrigger';
import Lightbox from '../../components/Lightbox';
export default class GalleryPage extends Page {
	constructor() {
		super({
			element: '.gallery',
			elements: {
				items: '.gallery__item',
			},
		});

		this.isMobile = window.matchMedia('(max-width: 999px)');
		this.id = 'gallery';
		this.isCreated = false;
	}

	create() {
		if (this.template != this.id) return;

		if (!this.isReady) super.createComponent();

		if (!this.isCreated) {
			this.components = {
				// about: new AboutSection(),
				// gallery: new GallerySection(),
				// repr: new ReprSection(),
				// contact: new ContactSection(),
				// gallery: new GallerySection(),
			};
			this.isCreated = true;
		}

		// Create Components
		each(this.components, (component) => {
			console.log('create component', component);
			component.create();
		});
		this.lightbox = new Lightbox();
		this.createScrollTrigger();
		this.addEventListeners();
		console.log(`🔼 ${this.id} is created`);
	}

	createScrollTrigger = () => {
		if (window.isMobile) return;
		this.allAnims = [];
	};

	show() {
		this.createScrollTrigger();
	}

	hide() {
		return new Promise((resolve) => {
			this.destroy();

			GSAP.to(this.element, {
				autoAlpha: 0,
				onComplete: resolve,
			});
		});
	}

	openLightbox(item, type = 'image') {
		console.log('Open Lightbox', this.isDragging);
		if (this.isDragging) return;
		this.lightbox.setActiveImage(item, type);
		this.lightbox.open();
	}

	addEventListeners() {
		console.log('BioPage addEventListeners 🔥🔥');
		each(this.components, (component) => {
			component.addEventListeners();
		});
		each(this.elements.items, (item) => {
			item.addEventListener('click', () => {
				this.openLightbox(item);
			});
		});
	}

	removeEventListeners() {
		each(this.components, (component) => {
			component.removeEventListeners();
		});
		each(this.elements.items, (item) => {
			item.removeEventListener('click', () => {
				this.openLightbox(item);
			});
		});
	}

	destroy() {
		this.removeEventListeners();
		super.destroy();

		each(this.components, (component) => {
			component.destroy();
		});

		// Removes scroll trigger instances
		const scrolltriggerElements = document.querySelectorAll('.pin-spacer');
		each(scrolltriggerElements, (pinSpacer) => {
			const parent = pinSpacer.parentElement;

			while (pinSpacer.firstChild) {
				parent.appendChild(pinSpacer.firstChild);
			}

			parent.removeChild(pinSpacer);
		});
	}

	update() {
		if (
			this.components &&
			this.components.selection &&
			this.components.selection.isReady
		)
			this.components.selection.update();
	}

	updateMousePos(e) {
		if (
			this.components &&
			this.components.selection &&
			this.components.selection.isReady
		)
			this.components.selection.updateMousePos(e);
	}

	onResize() {
		console.log('resize design');
		each(this.components, (component) => {
			if (component.onResize) component.onResize();
		});
	}
}
